import { defineStore } from 'pinia';

// eslint-disable-next-line import/prefer-default-export
export const useNotificationCountersStore = defineStore({
	id: 'notificationCounters',
	state: () => ({
		newRfps: 0,
		newContacts: 0,
		newChats: 0,
		newChatsList: [],
		totalUnreadNotifications: 0,
		totalUnread: 0,
	}),
	actions: {
	},
});
